import { graphql } from '@prophecy/graphql-types/graphql';
export const releaseProjectQuery = graphql(`
  mutation releaseProject(
    $projectId: String!
    $version: String!
    $message: String!
    $commitHash: String
    $branch: String
    $shouldReleaseCurrentVersion: Boolean
  ) {
    releaseProject(
      uid: $projectId
      releaseVersion: $version
      releaseNotes: $message
      commitHash: $commitHash
      branch: $branch
      shouldReleaseCurrentVersion: $shouldReleaseCurrentVersion
    )
  }
`);
export const isProjectAdminQuery = graphql(`
  query isProjectAdminQuery($projectId: String!) {
    isProjectAdmin(uid: $projectId)
  }
`);
export const versionsQuery = graphql(`
  query Versions($projectId: String!, $excludeMergeCommits: Boolean) {
    Versions(projectUID: $projectId, excludeMergeCommits: $excludeMergeCommits) {
      version
      created
      commitHash
      commits {
        commitHash
        message
        created
        authorEmail
        authorName
        tags
        version
      }
      versionType
      tagMessage
      authorName
      lastDeploymentId
      lastDeploymentTime
      status
      fabrics {
        id
        name
      }
      projectParameterSet
    }
  }
`);
export const deployOrchestratorProjectMutation = graphql(`
  mutation deployOrchestratorProject(
    $projectId: String!
    $version: String!
    $fabricIds: [String!]!
    $projectParameterSet: String!
    $scheduleDecisions: [ScheduleDecisionInput!]
  ) {
    deployOrchestratorProject(
      uid: $projectId
      releaseVersion: $version
      fabricIds: $fabricIds
      projectParameterSet: $projectParameterSet
      scheduleDecisions: $scheduleDecisions
    )
  }
`);
export const bumpVersionSuggestionsQuery = graphql(`
  query bumpVersionSuggestions($projectId: String!, $branch: String) {
    bumpVersionSuggestions(uid: $projectId, branch: $branch)
  }
`);
export const bumpVersionProjectQuery = graphql(`
  mutation bumpVersionProject($projectId: String!, $branch: String!, $bumpVersion: String!) {
    bumpVersionProject(uid: $projectId, branch: $branch, bumpVersion: $bumpVersion)
  }
`);
export const latestVersionDetailQuery = graphql(`
  query latestVersionDetail($projectId: String!, $branch: String) {
    latestVersionDetail(uid: $projectId, branch: $branch) {
      latestVersion
      isReleased
    }
  }
`);
